const CURRENCY_FORMATTER = new Intl.NumberFormat(
  undefined, {
  currency: "AUD",
  style: "currency",
})

export const delay = (ms: number | undefined) => new Promise(res => setTimeout(res, ms));

export function formatCurrency(number: number) {
  return CURRENCY_FORMATTER.format(number)
}
